var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovaPoshta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0420\\u0401\\u0420\\xB0\\u0421\\u0402_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.4 171.39",
    style: {
      enableBackground: "new 0 0 171.4 171.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EB3323;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0420\\u040E\\u0420\\xBB\\u0420\\u0455\\u0420\\u2116_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.77,139.11v-35.65H70.55v35.65H47.42l28.05,28.06c5.64,5.62,14.76,5.62,20.4,0l28.06-28.06H100.77z  M32.26,123.99V47.4L4.22,75.45c-5.63,5.63-5.63,14.77,0,20.4L32.26,123.99z M70.52,32.23v35.64h30.25V32.23h23.16l-28.1-28 c-5.63-5.63-14.77-5.63-20.4,0l-28.02,28H70.52z M167.08,75.41l-28.03-28v76.51l28.06-28.06c5.66-5.58,5.73-14.68,0.15-20.34 c-0.01-0.01-0.02-0.02-0.03-0.03c0,0,0,0-0.12,0L167.08,75.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaPoshta);
export default __webpack_public_path__ + "static/media/nova-poshta.2f72839dd03ee8f2d66c2585bb257b72.svg";
export { ForwardRef as ReactComponent };